import { TitleVariantsType, ParagraphSizesType, ParagraphWeightType, ParagraphVariantsType, } from '../../../designSystem/reloaded/commons/components/variants';
export const titleProps = {
    variant: TitleVariantsType.DEFAULT,
    size: ParagraphSizesType.LARGE,
    weight: ParagraphWeightType.BOLD,
};
export const paragraphProps = {
    variant: ParagraphVariantsType.DEFAULT,
    size: ParagraphSizesType.MEDIUM,
    weight: ParagraphWeightType.REGULAR,
};
//# sourceMappingURL=empty-status-props.js.map